import type { FunctionComponent } from 'react';
import YearsField from './YearsField';

const Retired: FunctionComponent = function () {
  return <YearsField status="retired" />;
};

export default Retired;
